/** vuex store for datastore module  */
export const discoveryTool = {
  namespaced: true,
  /** state (data) */
  state: () => ({
    selectedIndicators: [],
    loadingIndicators: true,
    selectIndicatorsDialog: false,
    areaMouseOverInfo: {},
    indicators: [],
  }),
  /** setters */
  mutations: {
    setSelectedIndicators(state, value) {
      state.selectedIndicators = value;
    },
    setLoadingIndicators(state, value) {
      state.loadingIndicators = value;
    },
    setSelectIndicatorsDialog(state, value) {
      state.selectIndicatorsDialog = value;
    },
    setAreaMouseOverInfo(state, value) {
      state.areaMouseOverInfo = value;
    },
    setIndicators(state, value) {
      state.indicators = value;
    },
  },
  /** getters */
  getters: {
    selectedIndicators: (state) => state.selectedIndicators,
    loadingIndicators: (state) => state.loadingIndicators,
    selectIndicatorsDialog: (state) => state.selectIndicatorsDialog,
    areaMouseOverInfo: (state) => state.areaMouseOverInfo,
    indicators: (state) => state.indicators,
  },
};
